'use strict';

class Route {
  constructor(path) {
    this.path = path;
  }
}

module.exports = Route;



// WEBPACK FOOTER //
// ../autor/src/route.js